import styled from "styled-components";
import { Link } from "react-router-dom";

export const CardLink = styled(Link)`
  text-decoration: none !important;

  &.big-card {
    width: 144px;
    height: 205px;
    font-size: 16px;

    @media (min-width: 768px) {
      width: 202px;
      height: 288px;
    }
  }

  &.small-card {
    width: 101px;
    height: 144px;
    font-size: 12px;

    @media (min-width: 768px) {
      width: 126px;
      height: 185px;
    }
  }
`;

export const ThumbImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 5px;

  &.fit-cover {
    object-fit: cover;
  }
`;

export const ThumbContainer = styled.div`
  cursor: pointer;
  width: 100%;
  height: 100%;
  position: relative;
`;

export const ThumbCaption = styled.div`
  width: 100%;
  height: 38%;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  background: linear-gradient(180deg, rgba(32, 30, 32, 0) 0%, #201e20 100%);
  opacity: 0.9;
  transition: all 0.3s;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;

  ${ThumbContainer}:hover & {
    opacity: 1;
  }

  p {
    text-align: left;
    margin-left: 10px;
    margin-right: 5px;
    color: #ffffff;
    font-family: "MaisonNeue", sans-serif;
  }
`;
